export default class SpinnerExtension {
	initialize(naja) {
		this.globalSpinner = this.createSpinner();
		document.body.appendChild(this.globalSpinner);

		naja.uiHandler.addEventListener('interaction', (event) => {
			event.detail.options.spinner = this.globalSpinner;
		});

		naja.addEventListener('start', () => this.toggleSpinner(true));
		naja.snippetHandler.addEventListener('afterUpdate', () => this.toggleSpinner(false));
		naja.snippetHandler.addEventListener('error', () => this.toggleSpinner(false));
		naja.addEventListener('complete', (event) => {
			if (!event.detail.snippets) {
				this.toggleSpinner(false);
			}
		});

		document.addEventListener('click', (event) => this.updateSpinnerMessage(event));
	}

	toggleSpinner(show) {
		if (this.globalSpinner) {
			this.globalSpinner.style.display = show && localStorage.getItem('disable-spinner') !== 'true' ? '' : 'none';
		}
	}

	updateSpinnerMessage(event) {
		const elem = event.target.closest('[data-spinner-text]');
		if (elem) {
			const message = elem.getAttribute('data-spinner-text');
			if (message) {
				this.globalSpinner.querySelector('[data-naja-loader-message]').textContent = message;
			}
		}
	}

	createSpinner() {
		const icon = document.createElement('i');
		icon.classList.add('fa-duotone', 'fa-spinner', 'fa-spin-pulse', 'me-3');
		icon.style.fontSize = '1.2rem';
		icon.style.verticalAlign = 'middle';

		const message = document.createElement('span');
		message.setAttribute('data-naja-loader-message', '');
		message.textContent = 'Požadavek se zpracovává, čekejte prosím...';

		const content = document.createElement('div');
		content.setAttribute('id', 'ajax-spinner');
		content.append(icon, message);

		const spinnerContainer = document.createElement('div');
		spinnerContainer.setAttribute('id', 'ajax-cover');
		spinnerContainer.style.display = 'none';
		spinnerContainer.appendChild(content);

		return spinnerContainer;
	}
}